import type { SxProps, Theme } from '@mui/material';
import type { ReactNode } from 'react';
import { Text } from '@/components/ui/text';
import { FormTipWrap } from './FormTip.styles';

interface IFormTip {
    crit?: boolean;
    icon?: ReactNode;
    children: ReactNode;
    disabled?: boolean;
    sx?: SxProps<Theme>;
}

export const FormTip = ({ crit, icon, children, disabled, sx }: IFormTip) => {
    return (
        <FormTipWrap isCrit={crit} disabled={disabled} sx={sx}>
            {icon}
            <Text variant="body2" color="text-inherit" children={children} />
        </FormTipWrap>
    );
};
